/* Version: 3.5.149 */
'use client';
import 'react';
import { ButtonPlusFilled, ButtonMinusOutlined } from '@manulife/mux-cds-icons';
import PropTypes from 'prop-types';
import { rem } from '../../utils/functions.js';
import { ACCORDION_VARIANT } from './constants.js';
import MinusIcon from './MinusIcon.js';
import PlusIcon from './PlusIcon.js';
import { applyDefaultProps } from './utils.js';
import { jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';

var HeaderIcon = function HeaderIcon(_ref) {
  var isExpanded = _ref.isExpanded,
    expandIcon = _ref.expandIcon,
    collapseIcon = _ref.collapseIcon,
    variant = _ref.variant;
  var theme = useTheme();
  if (isExpanded && collapseIcon) {
    return applyDefaultProps(collapseIcon, variant, theme);
  }
  if (!isExpanded && expandIcon) {
    return applyDefaultProps(expandIcon, variant, theme);
  }
  if (variant === ACCORDION_VARIANT.PRIMARY && !isExpanded) {
    return /*#__PURE__*/jsx(ButtonPlusFilled, {
      viewBox: "1 1 18 18" // NOTE: This fixes a bug with the icons having incorrect inner padding
      ,
      fontSize: rem(20),
      color: theme.colorPalette.accentColor.shade_default,
      "data-testid": "plus-with-circle"
    });
  }
  if (variant === ACCORDION_VARIANT.PRIMARY && isExpanded) {
    return /*#__PURE__*/jsx(ButtonMinusOutlined, {
      viewBox: "1 1 18 18" // NOTE: This fixes a bug with the icons having incorrect inner padding
      ,
      fontSize: rem(20),
      color: theme.colorPalette.accentColor.shade_default,
      "data-testid": "minus-with-circle"
    });
  }
  if (!isExpanded) {
    return /*#__PURE__*/jsx(PlusIcon, {
      fill: theme.colorPalette.accentColor.shade_default,
      "data-testid": "plus"
    });
  }
  return /*#__PURE__*/jsx(MinusIcon, {
    fill: theme.colorPalette.accentColor.shade_default,
    "data-testid": "minus"
  });
};
process.env.NODE_ENV !== "production" ? HeaderIcon.propTypes = {
  /** current state of expansion panel */
  isExpanded: PropTypes.bool,
  /** Icon component to pass for collapsed state */
  expandIcon: PropTypes.node,
  /** Icon component to pass for expanded state */
  collapseIcon: PropTypes.node,
  /** Which style of accordion to use */
  variant: PropTypes.oneOf([ACCORDION_VARIANT.PRIMARY, ACCORDION_VARIANT.SECONDARY, ACCORDION_VARIANT.LEGAL])
} : undefined;
process.env.NODE_ENV !== "production" ? HeaderIcon.displayName = 'HeaderIcon' : undefined;

export { HeaderIcon as default };
